import React from 'react';
import { Box, Typography, Stack, Button, Alert } from '@mui/material';
import { Add, NoteAdd } from '@mui/icons-material';
import { useAppSelector } from '../../../../app/store';
import { AddNoteDialog, useAddNoteDialog, NotesGrid } from '../index';
import SectionPaper from '../../../common/components/styled-ui-elements/SectionPaper';

export const NotesSection: React.FC = () => {
  const { currentRefund } = useAppSelector(state => state.refund);
  const notes = currentRefund?.notes || [];
  
  const { open: showAddDialog, openDialog: openAddDialog, closeDialog: closeAddDialog } = useAddNoteDialog();

  return (
    <>
      {/* Header Section */}
      <SectionPaper sx={{ mb: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" alignItems="center" gap={1.5}>
            <NoteAdd sx={{ color: '#3b82f6', fontSize: 24 }} />
            <Box>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 600, 
                  color: '#1e293b',
                  mb: 0.5
                }}
              >
                Refund Notes
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ color: '#64748b' }}
              >
                {notes.length === 0 
                  ? 'No notes have been added to this refund yet' 
                  : `${notes.length} note${notes.length !== 1 ? 's' : ''} recorded`
                }
              </Typography>
            </Box>
          </Stack>

          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={openAddDialog}
            sx={{
              backgroundColor: '#162346',
              fontWeight: 600,
              px: 3,
              '&:hover': {
                backgroundColor: '#1a2a52'
              }
            }}
          >
            Add Note
          </Button>
        </Stack>
      </SectionPaper>

      {/* Notes Grid Section */}
      <SectionPaper 
        sx={{ 
          border: '1px solid #e2e8f0',
          borderRadius: 1.5,
          overflow: 'hidden',
          p: 0
        }}
      >
        {notes.length === 0 ? (
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <Alert 
              severity="info" 
              sx={{ 
                backgroundColor: '#f0f9ff',
                border: '1px solid #bae6fd',
                '& .MuiAlert-icon': {
                  color: '#0284c7'
                }
              }}
            >
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                No notes available
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: '#64748b' }}>
                Click "Add Note" to create the first note for this refund
              </Typography>
            </Alert>
          </Box>
        ) : (
          <NotesGrid />
        )}
      </SectionPaper>

      {/* Dialogs */}
      <AddNoteDialog
        open={showAddDialog}
        onClose={closeAddDialog}
      />
    </>
  );
};

export default NotesSection;
